import {TypographyProp, TypographySize} from '../../../hooks/typography';

// eslint-disable-next-line @typescript-eslint/naming-convention
export enum INPUT_SIZE {
    SMALL = 'small',
    MEDIUM = 'medium',
    LARGE = 'large',
}

export const typographyProps: TypographyProp[] = [
    {
        size: TypographySize.BodyXL,
        noDefaultColor: true,
    },
    {
        size: TypographySize.BodyL,
        noDefaultColor: true,
    },
    {
        size: TypographySize.BodyS,
        noDefaultColor: true,
    },
];

export const DATE_TIME_TYPES: Array<React.InputHTMLAttributes<HTMLInputElement>['type']> = [
    'date',
    'time',
    'datetime-local',
    'week',
];
